var receiveMessage = function (event) {
  const {data, origin} = event;

  if(origin.includes('pricehubble') && data === '[iFrameResizerChild]Ready') {
    iframeResize({
      waitForLoad: false,
      license: 'GPLv3',
    }, '#resizableIframe' )
  }
}
window.addEventListener('message', receiveMessage, false)
